/*eslint-disable */
import request from '../../Utils/curl';

let PayCache = {
  /**
   * pay_cache_edit
   */
  async pay_cache_edit (context, payload) {
    try{
    let post_data = new FormData();
    
    for (let key in payload) {
      post_data.append(key, payload[key]);
    }

    return await request.curl(context, "pay_cache_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at pay_cache_edit() and Exception:',err.message)
    }
  },
};

export {
  PayCache
}
